import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";
import { zObjectId, zodPagination, zSubcategory } from "@dobrh-monorepo/core";

const requestSchema = z.object({
  categoryId: zObjectId(),
  searchText: z.string().optional(),
  ...zodPagination(),
});
const responseSchema = zSubcategory.array();

export default {
  method: HttpMethodEnum.GET,
  paramsType: HttpParamsTypeEnum.QUERY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
